document.addEventListener("DOMContentLoaded", () => {
  document.body.classList.add("content-protection-enabled");

  const block = (e) => e.preventDefault();

  document.addEventListener("contextmenu", block);
  document.addEventListener("selectstart", block);
  document.addEventListener("copy", block);
  document.addEventListener("cut", block);
  document.addEventListener("paste", block);

  document.addEventListener("keydown", (e) => {

    // ✅ Allow Ctrl + Shift + C (Inspect Element)
    // if (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "c") {
    //   return;
    // }

    // ❌ Block other Ctrl / Cmd shortcuts
    if (
      (e.ctrlKey || e.metaKey) &&
      ['x','v','a','s','p','u'].includes(e.key.toLowerCase())
    ) {
      block(e);
    }

    // ❌ Block DevTools shortcuts except Ctrl+Shift+C
    // if (
    //   e.key === "F12" ||
    //   (e.ctrlKey && e.shiftKey && e.key.toLowerCase() === "i")
    // ) {
    //   block(e);
    // }
  });
});
